import script from "./IssueCard.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueCard.vue?vue&type=script&setup=true&lang=js"

import "./IssueCard.vue?vue&type=style&index=0&id=ab7a8f32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab7a8f32"]])

export default __exports__